module.exports = {
  apiKey: 'AIzaSyACod-m2xLnUdI7fahrFHZZt_OxPqHmJkw',
  authDomain: 'nessti2e.firebaseapp.com',
  databaseURL: 'https://nessti2e.firebaseio.com',
  projectId: 'nessti2e',
  storageBucket: 'nessti2e.appspot.com',
  messagingSenderId: '484275823609',
  appId: '1:484275823609:web:8e56e7ca99bbbc3c',
  measurementId: 'G-0LBSR3174H',
};
